import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem,PrimeIcons,PrimeNGConfig} from 'primeng/api';

@Component({
  selector: 'app-create-template',
  templateUrl: './create-template.component.html',
  styleUrls: ['./create-template.component.scss']
})
export class CreateTemplateComponent implements OnInit {
  items: MenuItem[];
  events1: any[];
  checked: boolean = false;
  checked1: boolean = false;
  checked2: boolean = true;

  products: Product[];
    
    constructor(private productService: ProductService, private primengConfig: PrimeNGConfig) { }

    ngOnInit() {
        this.productService.getProductsSmall().then(cars => this.products = cars);
        this.primengConfig.ripple = true;
        this.items = [
          {label: 'Menu'},
          {label: 'Menu Active'},
        ];
    }

}
